import React from 'react';
import { IReport2 } from '../models/General';

export default function DashboardTable2(list:any) {

    const data:IReport2[] = list.data;

    const checkColor = (value:string, color:string) => {
        return value === "-1" ? 'rowcolorwl' : color;
    }

    const renderReport = () => {
        return data.map((item, index) => {
          return (
            <React.Fragment>
                <tr key={index}>
                    <td>{index + 1}</td>
                    <td className="rowcustome">{item.APPROVAL}</td>
                    <td className={checkColor(item.TOTAL_WL1,"rowcolorwl1")}>{item.TOTAL_WL1}</td>
                    <td className={checkColor(item.APPROVE_WL1,"rowcolorwl1")}>{item.APPROVE_WL1}</td>
                    <td className={checkColor(item.ONPROGRESS_WL1,"rowcolorwl1")}>{item.ONPROGRESS_WL1}</td>
                    <td className={checkColor(item.TOTAL_WL2,"rowcolorwl2")}>{item.TOTAL_WL2}</td>
                    <td className={checkColor(item.APPROVE_WL2,"rowcolorwl2")}>{item.APPROVE_WL2}</td>
                    <td className={checkColor(item.ONPROGRESS_WL2,"rowcolorwl2")}>{item.ONPROGRESS_WL2}</td>
                    <td className="rowcolorwl3">{item.TOTAL_WL3}</td>
                    <td className="rowcolorwl3">{item.APPROVE_WL3}</td>
                    <td className={checkColor(item.REJECT_WL3,"rowcolorwl3")}>{item.REJECT_WL3}</td>
                    <td className="rowcolorwl3">{item.ONPROGRESS_WL3}</td>
                </tr>
            </React.Fragment>
            );
        })
    }

    return (
        <React.Fragment>
            <div className="card-body table-responsive p-0 tablecustome" >
                <table className="table table-bordered table-striped">
                    <thead>
                        <tr>
                            <th className="rowReport" rowSpan={2}>#</th>
                            <th className="rowReport" rowSpan={2}>Approval</th>
                            <th className="rowReport rowcolorwl1" colSpan={3}>Warning Letter 1</th>
                            <th className="rowReport rowcolorwl2" colSpan={3}>Warning Letter 2</th>
                            <th className="rowReport rowcolorwl3" colSpan={6}>Warning Letter 3</th>
                        </tr>
                        <tr>
                            <th className="rowcolorwl1">Total</th>
                            <th className="rowcolorwl1">Approve</th>
                            <th className="rowcolorwl1">On Progress</th>
                            <th className="rowcolorwl2">Total</th>
                            <th className="rowcolorwl2">Approve</th>
                            <th className="rowcolorwl2">On Progress</th>
                            <th className="rowcolorwl3">Total</th>
                            <th className="rowcolorwl3">Approve</th>
                            <th className="rowcolorwl3">Reject</th>
                            <th className="rowcolorwl3">On Progress</th>
                        </tr>
                    </thead>
                    <tbody>
                        { renderReport()}
                    </tbody>
                </table>
            </div>
        </React.Fragment>
   )

}